module.exports = __webpack_public_path__ + "static/Reports-34ff5fe7c9f0a68bc1359bc4bdb27821.png";